import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app">
        <Loader2 className="h-8 w-8 animate-spin text-brand-ink" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
